import courses from "./courses.json"
import modules from "./modules.json"
import assignments from "./assignments.json"
const db = {courses, modules, assignments}
export default db;